module.exports = __webpack_public_path__ + "assets/Cut2Rectangles.cf0bd5a73f0cd2a1a8961810f716d44c.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Cut2Rectangles.gmt
// module id = 932
// module chunks = 0